import React from 'react';
import {Button, Container} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
    faBolt, faBullseye, faMicrochip, faCalendarCheck, faShieldHalved
} from '@fortawesome/free-solid-svg-icons';
import {useClarity} from '../hooks/useClarity';

const HeroSection = () => {
    const {trackBookingClick} = useClarity();

    return (
        <section className="hero-section hero-enhanced text-white position-relative">
            <div className="hero-grid-overlay"/>
            <div className="hero-orb hero-orb-1"/>
            <div className="hero-orb hero-orb-2"/>

            <Container className="position-relative" style={{zIndex: 1}}>
                <div className="text-center">
                    <div className="hero-badge">
                        <span className="hero-badge-dot"/>
                        <span>CONSISTENT AI - REGULATED INDUSTRIES - UK DATA SOVEREIGNTY</span>
                    </div>

                    <h1 className="hero-title mb-3">
                        AI That <span className="text-gradient-glow">Reasons</span>, Not Guesses.
                    </h1>

                    <p className="hero-subtitle lead">
                        Cited, auditable, consistent AI for industries that can't afford
                        a wrong answer. Same question, same answer, every time.
                        Working pilot in 3–4 weeks.
                    </p>

                    <p className="hero-customer-line">
                        Currently deployed in UK-based financial services and compliance.
                    </p>

                    <div className="d-flex justify-content-center gap-3 flex-wrap mb-5">
                        <Button size="lg" className="cta-button-hero px-4 py-2"
                                href="https://cal.eu/jon-cooke/discovery-call"
                                onClick={() => trackBookingClick('hero-primary')}>
                            Book a Discovery Call
                        </Button>
                        <Button size="lg" variant="outline-light" className="cta-button-ghost px-4 py-2"
                                href="#the-journey">
                            See how it works →
                        </Button>
                    </div>

                    <div className="hero-stats-inline">
                        <div className="stat-item-inline">
                            <FontAwesomeIcon icon={faBolt} className="stat-icon"/>
                            <div className="stat-value">50ms</div>
                            <div className="stat-label">Inference</div>
                        </div>
                        <div className="stat-item-inline">
                            <FontAwesomeIcon icon={faBullseye} className="stat-icon"/>
                            <div className="stat-value">Trusted</div>
                            <div className="stat-label">Accuracy</div>
                        </div>
                        <div className="stat-item-inline">
                            <FontAwesomeIcon icon={faMicrochip} className="stat-icon"/>
                            <div className="stat-value">&lt;1GB</div>
                            <div className="stat-label">Model Size</div>
                        </div>
                        <div className="stat-item-inline">
                            <FontAwesomeIcon icon={faCalendarCheck} className="stat-icon"/>
                            <div className="stat-value">3–4 wks</div>
                            <div className="stat-label">To Value</div>
                        </div>
                        <div className="stat-item-inline">
                            <FontAwesomeIcon icon={faShieldHalved} className="stat-icon"/>
                            <div className="stat-value">Zero</div>
                            <div className="stat-label">Hallucination</div>
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    );
};

export default HeroSection;